/**
 * @name MOVEMENT_SPEEDS
 * @constant
 * @array
 * @description Array of variable movement speeds (indices match order of `MAGNIFICATIONS`)
 */
export const MOVEMENT_SPEEDS = [
    2,
    1.5,
    1.25,
    1,
    0.5
];